export const PWA_CONTACT_SHARE_PATH = '/api/pwa/share/contacts';

export const PWA_EXTERNAL_HANDOFF_PARAM = 'lf_external';
export const PWA_LINK_HANDOFF_ROUTE_PATTERN =
  /^\/(?:auth|signup|(?:en|hi)\/(?:auth|signup)|user(?:\/.*)?|admin(?:\/.*)?)$/;

// WhatsApp does not always identify its embedded browser. This is a best-effort
// fallback; normal HTTPS links remain the OS/WebAPK launch mechanism.
export function shouldOfferPwaLinkHandoff(url: URL, userAgent: string) {
  return (
    PWA_LINK_HANDOFF_ROUTE_PATTERN.test(url.pathname) &&
    /\bwhatsapp\b/i.test(userAgent) &&
    url.searchParams.get(PWA_EXTERNAL_HANDOFF_PARAM) !== '1'
  );
}
